import {ReactElement, ReactNode} from "react";
import {SubTitle} from "../../../components/UIComponents/SubTitle";
import {FormattedMessage} from "react-intl";
import {useAppDispatch} from "../../../lib/redux/hooks";
import {EditorItemKey, menuEditorActions} from "../editorSlice";
import {ReactComponent as ArrowUp} from "../../../components/Icons/arrow-up.svg";
import {ReactComponent as ArrowDown} from "../../../components/Icons/arrow-down.svg";


export function PositionControl(
    {itemKey}: {itemKey: EditorItemKey}
): ReactElement {
    const dispatch = useAppDispatch();

    const move = (dir: number) => {
        dispatch(menuEditorActions.moveItemByDir({itemKey, dir}));
    };

    return <div className="px-6 flex flex-col gap-4 py-6">
        <SubTitle><FormattedMessage id="editor.position"/></SubTitle>

        <div className="flex gap-2 text-center">
            <PositionButton
                children={<ArrowUp/>}
                onClick={()=>move(-1)}
            />
            <PositionButton
                children={<ArrowDown/>}
                onClick={()=>move(1)}
            />
        </div>
    </div>;
}

function PositionButton(
    {children, onClick}: {children: ReactNode, onClick: ()=>void}
): ReactElement {
    return <div className="grow rounded hover:bg-gray-3 cursor-pointer p-1 select-none flex justify-center text-text"
                onClick={onClick}
    >
        {children}
    </div>;
}